// Matches the @bui-token-screen-md design token (768px). Not imported as a value from
// @btnet/blueprint-design-tokens because that package's exports resolve only to generated
// dist/ output, which isn't built before Clients.App's CI test job runs (ado-285796) — a
// value import here fails to resolve in CI while passing locally. Revisit once that's fixed.
export const MD_BREAKPOINT = 768;
